import { type ClassValue, clsx } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

/**
 * Parse a date string (YYYY-MM-DD) as a local date, not UTC.
 * This prevents the off-by-one-day bug when displaying dates.
 * 
 * new Date("2024-12-02") → midnight UTC → Dec 1 in EST
 * parseLocalDate("2024-12-02") → midnight local → Dec 2 in EST
 */
export function parseLocalDate(dateStr: string): Date {
  if (!dateStr) return new Date();
  
  // If it's already a full ISO string with time, parse normally
  if (dateStr.includes('T')) {
    return new Date(dateStr);
  }
  
  // For date-only strings (YYYY-MM-DD), parse as local time
  const [year, month, day] = dateStr.split('-').map(Number);
  return new Date(year, month - 1, day);
}